import { Grid, Box, Typography, Chip } from "@mui/material";
import React from "react";

function DayOfWeek({ day, tasks = [], onClick, ...props }) {
  return (
    <Grid
      item
      xs={6}
      style={{
        overflow: "hidden",
        height: "30%",
      }}
    >
      <Box
        style={{
          padding: "1rem",
          border: "1px solid black",
          //   borderLeft: "1px solid black",
          //   borderRight: "1px solid black",
          //   height: "100%",
        }}
      >
        <Typography>{day}</Typography>
        {tasks.map((task) => {
          return (
            <Box
              key={task.storageDocumentId}
              style={{
                borderBottom: "1px solid black",
                // padding: "1rem",
                padding: "1rem 0",
              }}
              onClick={() => {
                onClick(task);
              }}
            >
              <Chip label={task.clientName} size="small" />
              {/* <Typography variant="subtitle2">{task.clientName}</Typography> */}
              <Typography variant="subtitle2">{task.description}</Typography>
            </Box>
          );
        })}
      </Box>
    </Grid>
  );
}

export default function TaskListWeekCalendar({ tasks, onClick }) {
  return (
    <Box>
      <Grid
        container
        spacing={2}
        style={
          {
            // height: "100vh",
          }
        }
      >
        <DayOfWeek
          day="Monday"
          tasks={tasks.filter((task) => {
            return task.scheduledDay === "Monday";
          })}
          onClick={onClick}
        />
        <DayOfWeek
          day="Tuesday"
          tasks={tasks.filter((task) => {
            return task.scheduledDay === "Tuesday";
          })}
          onClick={onClick}
        />
        <DayOfWeek
          day="Wednesday"
          tasks={tasks.filter((task) => {
            return task.scheduledDay === "Wednesday";
          })}
          onClick={onClick}
        />
        <DayOfWeek
          day="Thursday"
          tasks={tasks.filter((task) => {
            return task.scheduledDay === "Thursday";
          })}
          onClick={onClick}
        />
        <DayOfWeek
          day="Friday"
          tasks={tasks.filter((task) => {
            return task.scheduledDay === "Friday";
          })}
          onClick={onClick}
        />
      </Grid>
    </Box>
  );
}
